





















import { Vue, Component, Watch } from "vue-property-decorator";
import { Tabbar, TabbarItem } from "vant";

@Component({
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },
})
export default class Footer extends Vue {
  //componts
  get routerName(): string {
    return (this as any).$route.name;
  }
  active: string = "index";
  icon: object = {
    activeLeft: require("@/assets/icon/check-home.png"),
    inactiveLeft: require("@/assets/icon/home.png"),

    activeCenter: require("@/assets/icon/check-trip.png"),
    inactiveCenter: require("@/assets/icon/trip.png"),

    activeRight: require("@/assets/icon/check-my.png"),
    inactiveRight: require("@/assets/icon/my.png"),
  };
  systemVersion = "newApp";
  mounted() {
    this.active = this.routerName;
  }
  //watch
  @Watch("routerName", { deep: true })
  handleWatch(newVal: any, oldVal: any) {
    if (newVal) {
      this.active = newVal;
    } else {
      this.active = this.routerName;
    }
  }
}
